// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__sIIGp","footerList":"Footer_footerList__tNGla","footerContacts":"Footer_footerContacts__oqKRT"};